import { fetchCampaigns } from "./fetch-campaigns";

export const campaignRepo = {
  get: fetchCampaigns,
};
